import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';
import { ConfigService } from 'app/config/config.service';

export function useCloudfrontCookies(farmId: number) {
    if (!ConfigService.devMode)
        createAxiosInstance()
            .get(ApiEndpoint.cloudfrontAuth, { params: { farm_id: farmId } })
            .catch((e: unknown) => {
                console.error(e);
            });
}
